export default `:host {
  display: block;
  outline: none !important;
}

.redeemer-app {
  font-family: "Gotham", sans-serif;
  color: #3e4349;
}
.redeemer-app input {
  font-family: inherit;
}
.redeemer-app--search {
  position: relative;
}
.redeemer-app--search .search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #767676;
  pointer-events: none;
}
.redeemer-app .series {
  margin-top: 0.5rem;
}
.redeemer-app .series.is-highlighted .series--card {
  background-color: #d1ebfb;
}
.redeemer-app .series--title {
  font-size: 18px;
}
.redeemer-app .series--tag {
  color: #767676;
  font-size: 16px;
  font-weight: 400;
  font-family: "Georgia", serif;
}
.redeemer-app .series--sermons {
  padding: 0;
  margin: 0;
  list-style: none;
}
.redeemer-app .series--card {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.2s;
}
.redeemer-app .series--card:hover, .redeemer-app .series--card:focus-within {
  background-color: #e1f3ff;
}
.redeemer-app .series--content {
  flex: 1;
  align-self: center;
  min-width: 0;
}
.redeemer-app .series--sermons-toggle {
  flex: 0 0 fit-content;
  align-self: center;
}
@media (max-width: 676px) {
  .redeemer-app .series--sermons-toggle {
    display: none;
  }
}
.redeemer-app .series--image-wrapper {
  flex: 0 0 min(25%, 120px);
  display: flex;
}
.redeemer-app .series--image {
  max-width: 100%;
  aspect-ratio: 4/3;
  object-fit: cover;
  object-position: center;
}
.redeemer-app .series--sermon {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.2s;
}
.redeemer-app .series--sermon:hover, .redeemer-app .series--sermon:focus-within {
  background-color: #e1f3ff;
}
.redeemer-app .series--sermon.is-highlighted {
  background-color: #d1ebfb;
}
.redeemer-app .series--sermon--number {
  font-family: "Georgia", serif;
  flex: 0 0 min(12.5%, 60px);
  font-size: 24px;
  font-weight: 700;
  display: flex;
  justify-content: end;
  align-items: center;
}
.redeemer-app .series--sermon--link {
  margin-left: auto;
  align-self: center;
  color: #000;
  text-decoration: none;
  padding: 5px 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  width: 90px;
  height: 35px;
}
.redeemer-app .series--sermon--link .fa {
  font-size: 1em;
}
.redeemer-app .series--sermon--mid-col {
  flex-shrink: 1;
  overflow: hidden;
}
.redeemer-app .series--meta,
.redeemer-app .series--sermon--meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 0.5rem;
  row-gap: 0;
  min-width: 0;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}
.redeemer-app .series--meta > span,
.redeemer-app .series--sermon--meta > span {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  flex: 0 0 fit-content;
  text-overflow: ellipsis;
  max-width: 250px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.redeemer-app .series--meta .lucide,
.redeemer-app .series--sermon--meta .lucide {
  color: #767676;
  width: 16px;
  height: 16px;
}
.redeemer-app .filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.redeemer-app .filters--group {
  flex: 1 1 calc(33.33% - 0.5rem);
  min-width: 200px;
}
.redeemer-app .filters--group label {
  display: block;
  font-size: 14px;
  color: white;
}
@media (max-width: 676px) {
  .redeemer-app .filters {
    gap: 0;
  }
  .redeemer-app .filters--group {
    flex: 1 1 100%;
    margin-bottom: 0;
  }
}
.redeemer-app .series--sermon-dialog {
  padding: 4rem;
  background-color: white;
  border-radius: 0;
  max-width: 1200px;
  width: calc(100vw - 2rem);
  box-sizing: border-box;
  border: none;
}
@media (max-width: 676px) {
  .redeemer-app .series--sermon-dialog {
    padding: 2rem;
    padding-bottom: 1rem;
  }
}
.redeemer-app .series--sermon-dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.3333333333);
}
.redeemer-app .series--sermon-dialog--close {
  position: absolute;
  top: 16px;
  right: 16px;
}
.redeemer-app .series--sermon--player {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}
.redeemer-app .series--sermon--player > * {
  flex: 1;
}
.redeemer-app .series--sermon--player-metadata {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 0 1 auto;
}
.redeemer-app .series--sermon--player-metadata p {
  margin: 0;
}
.redeemer-app .series--sermon--player-controls {
  flex: 1 0 300px;
  max-width: 100%;
}
@media (max-width: 676px) {
  .redeemer-app .series--sermon--player-controls {
    flex: 1 0 auto;
  }
}
@media (max-width: 676px) {
  .redeemer-app .series--sermon--player {
    flex-direction: column;
    gap: 1rem;
  }
}
.redeemer-app .series--sermon--player-audio, .redeemer-app .series--sermon--player-video {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.redeemer-app .series--sermon--player-audio-backdrop {
  width: 100%;
}
.redeemer-app .series--sermon--player-audio-backdrop img {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
}
.redeemer-app .series--sermon--player-audio-backdrop audio {
  width: 100%;
}
.redeemer-app .series--sermon--player-audio-backdrop audio::-webkit-media-controls-panel {
  border-radius: 0;
  background-color: white;
  padding: 0.25rem 0.5rem;
}
.redeemer-app .series--sermon--player-audio-backdrop audio::-webkit-media-controls-enclosure {
  border-radius: 0;
}

.gil-button {
  padding: 10px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 0;
  border: 1px solid #000;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  color: #3e4349;
}
.gil-button a {
  color: #000;
  text-decoration: none;
}

h3 {
  font-size: 22px;
  margin: 0 0 5px;
  color: #3e4349;
  line-height: normal;
}
@media (max-width: 676px) {
  h3 {
    font-size: 18px;
  }
}

.tag {
  font-weight: bold;
}

.search {
  display: block;
  border: none;
  font-size: 16px;
  border-radius: 0;
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
  margin: 1rem 0;
}
.search:focus {
  outline: 1px solid #d1ebfb;
}

.gil-select__input {
  font-size: 14px !important;
}

.gil-select__multi-value {
  border-radius: 0 !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
